import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import * as $ from 'jquery';
import {FormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {CommonService} from "../../../../services/common.service";

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['../../styles.css', './otp-input.component.css']
})
export class OtpInputComponent implements AfterViewInit, OnDestroy {
  @ViewChild('input') input: ElementRef | undefined;

  @Input() focus: boolean = false;
  @Input() placeholder: string = '';
  @Input() error: string = '';
  @Input() parentFormGroup: FormGroup = new FormGroup<any>({});
  @Input() controlName: string;

  @Output() getOtpString = new EventEmitter();
  @Output() checkForErrors = new EventEmitter();

  fieldSubscription: Subscription | undefined;

  otp = '';
  isRequired: boolean = false;
  isDisabled: boolean = false;

  otpValue = {
    0: '',
    1: '',
    2: '',
    3: '',
    4: '',
    5: '',
  }

  otpLooperArr = Object.keys(this.otpValue);

  constructor(
    private cdRef: ChangeDetectorRef,
    private commonService: CommonService
  ) {
  }

  @HostListener('paste', ['$event'])
  onPaste(e) {
    e.preventDefault();
    this.commonService.notification('Paste is not allowed', 'warning');
  }

  @HostListener('copy', ['$event'])
  onCopy(e) {
    e.preventDefault();
    this.commonService.notification('Copy is not allowed', 'warning');
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): any {
    const index = Number(e.target['id']?.split('-')[1]);
    if (e.key !== 'Unidentified') {
      if (!['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(e.key)) {
        e.preventDefault();
      }

      if ([
            '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'
          ].includes(e.key) && e.target['value'].length) {
        e.preventDefault();
      }
    } else {
      let value = e.target['value'];
      if (value.length) {
        $('#otp-' + index).val('');
      }
    }

    if (e.key === 'Backspace') {
      if ($('#otp-' + index).val()) {
        this.otpValue[index] = '';
      } else {
        $('#otp-' + (index - 1)).focus();
      }
    }
  }

  @HostListener('keyup', ['$event'])
  onKeyUp(e: KeyboardEvent): any {
    const index = Number(e.target['id']?.split('-')[1]);
    if (e.key !== 'Unidentified') {

      if ([
            '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'
          ].includes(e.key) && e.target['value'].length) {
        $('#otp-' + index).val(e.key);
        $('#otp-' + (index + 1)).focus();
      }

      if (e.key === 'Backspace') {
        if (e.target['value'].length) {
          $('#otp-' + index).val('');
        } else {
          $('#otp-' + (index - 1)).focus();
        }
      }
    } else {
      const value: any = $('#otp-' + index).val();
      if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(value)) {
        $('#otp-' + (index + 1)).focus();
      } else {
        $('#otp-' + index).val('');
      }
    }

    this.otp = Object.values(this.otpValue).join('')

    this.parentFormGroup.controls[this.controlName].setValue(this.otp);
  }

  ngAfterViewInit() {
    $('#otp-0').focus();
    this.cdRef.detectChanges();
  }


  ngOnDestroy() {
    this.cdRef.detach();
  }
}
